import Form1 from "./form_pages/Form1";

function App() {
  return (
    <Form1/>
  );
}

export default App;
